export enum UserArchivedFilter {
    Active = 0,
    All = 1,
    Archived = 2
}
